var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"layer",class:['layer', {
        availableLayer: _vm.availableLayer,
        active: _vm.showControls,
        topLevel: _vm.layer.toplevel
    }],style:({'z-index': _vm.layer.toplevel ? 10000 : _vm.index,
        'pointer-events': _vm.notActiveClass || _vm.layer.toplevel ? 'none' : '',
        opacity: _vm.notActiveClass ? 0.3 : 1
      }),attrs:{"id":'layer-' + _vm.id},on:{"click":_vm.activateLayer}},[_c(_vm.layer.type + 'Layer',{tag:"component",attrs:{"layer":_vm.layer,"id":_vm.layer.id},on:{"clicked":function($event){return _vm.$emit('editValue', $event)}}}),(_vm.showControls)?_c('layer-controls',{attrs:{"layerId":_vm.id},on:{"changeLayerIndex":_vm.changeLayerIndex,"removeLayer":_vm.removeLayer}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }